import React from 'react';
import { Splitview, Split, SplitContainer } from '../../Split';

import {
  OverviewContainer, Word, Grid, GridPanel, Legenda,
} from './styles';

type RelationOverviewProps = {
  title: String,
  subTitle: String,
  dependData: Object,
};

const RelationOverview = ({ title, subTitle, dependData }: RelationOverviewProps) => (
  <Splitview>
    <SplitContainer>
      <Split width={100}>
        <h2 className="question-heading">{title}</h2>
        <div className="question-description">
          <p>{subTitle}</p>
        </div>
        <OverviewContainer>
          <Grid>
            <GridPanel right>
              <Word isHeader>Dit is de moeite waard</Word>
              {dependData.inzetten.map(word => (
                <Word key={word} personal>
                  {word}
                </Word>
              ))}
            </GridPanel>
            <GridPanel>
              <Word isHeader>Dit zet de relatie onder druk</Word>
              {dependData.druk.map(word => (
                <Word key={word} partner>
                  {word}
                </Word>
              ))}
            </GridPanel>
          </Grid>
          <Grid>
            <GridPanel right>
              <Word isHeader right>
                Dit haal ik uit de relatie
              </Word>
              {dependData.waarde.map(word => (
                <Word key={word} personal right>
                  {word}
                </Word>
              ))}
            </GridPanel>
            <GridPanel>
              <Word isHeader>Dit investeer ik in de relatie</Word>
              {dependData.investeer.map(word => (
                <Word key={word} partner left>
                  {word}
                </Word>
              ))}
            </GridPanel>
          </Grid>
          <Legenda>
            <div className="legenda-item">
              <span className="legenda-color legenda-color--personal" />
              {' '}
              <span className="legenda-label">Voor mezelf</span>
            </div>
            <div className="legenda-item leganda-partner">
              <span className="legenda-color legenda-color--partner" />
              {' '}
              <span className="legenda-label">Voor relatie</span>
            </div>
          </Legenda>
        </OverviewContainer>
      </Split>
    </SplitContainer>
  </Splitview>
);

export default RelationOverview;
